import React, { RefObject } from 'react';
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';

import { FocusComponentProps } from '../../models/ComponentProps';
import { AlmeCloseIconConfig } from '../AlmeCloseIcon/AlmeCloseIconConfig';
import { useIntl } from 'react-intl';


const styles = (theme: Theme) => ({
    closeButton: {
        fontWeight: theme.typography.fontWeightBold,
        fontSize: theme.typography.h6.fontSize,
    },
});

export interface AlmeCloseIconProps extends WithStyles<typeof styles> {
    onClose: () => void;
    className?: string;
    focusProps?: FocusComponentProps;
    almeConfig: AlmeCloseIconConfig;
    forwardRef?: RefObject<HTMLButtonElement>;
    id: string;
}

export const AlmeCloseIcon = withStyles(styles)((props: AlmeCloseIconProps) => {
    const { classes, onClose, className, focusProps, almeConfig, forwardRef, ...other } = props;
    const closeClass = className ? `${classes.closeButton} ${className}` : classes.closeButton;
    const intl = useIntl();

    return (
        <IconButton color='inherit'
            title={intl.formatMessage({
                id: "closeIcon.closeIconTitle",
                defaultMessage: 'Default Close Icon',
                description: 'Close icon tool tip',
            })}

            className={closeClass} ref={props.forwardRef}
            onClick={onClose}
            {...focusProps}
            {...other}
        >
            <CloseIcon fontSize={props.almeConfig.closeIcon.styles.buttonSize || 'small'} />
        </IconButton>
    );
});